// extracted by mini-css-extract-plugin
var _1 = "DMzAw";
export { _1 as "base" }
